import { gql } from "@apollo/client";

const LEAGUE_STATS = gql`
  query leagueStats($federationId: Int, $filter: ListLeagueInput) {
    leagueStats(federationId: $federationId, filter: $filter)
  }
`;

export default LEAGUE_STATS;
